import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=c95e351a&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=ts&"
export * from "./NotFound.vue?vue&type=script&lang=ts&"
import style0 from "./error-page.scss?vue&type=style&index=0&id=c95e351a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95e351a",
  null
  
)

export default component.exports